import classNames from "classnames";

import styles from "./button.module.scss";

/* eslint-disable react/button-has-type */
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant: "secondary";
  size: "small";
};

export const Button = ({
  type,
  variant,
  size,
  className,
  ...props
}: ButtonProps) => (
  <button
    className={classNames(
      styles.button,
      {
        [styles.variantSecondary]: variant === "secondary",
        [styles.sizeSmall]: size === "small",
      },
      className,
    )}
    type={type}
    {...props}
  />
);
